import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Classroom.css";

function ClassroomPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content">
                <h1 className="main-title">Classroom Page</h1>
                <p className="main-description">Welcome to the Classroom page!</p>
            </main>
        </div>
    );
}

export default ClassroomPage;